// btw-front/src/pages/Partners.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import Container from "../components/ui/Container";
import { Button } from "../components/ui/Button";
import PartnerLoginCard from "../components/sections/PartnerLoginCard";

export default function Partners() {
  const { t } = useTranslation();

  return (
    <div id="top" className="flex min-h-screen flex-col">
      <Navbar />

      <main className="flex-1">
        {/* Header */}
        <section className="relative overflow-hidden bg-slate-950">
          {/* 은은한 글로우 */}
          <div className="pointer-events-none absolute -top-32 left-1/2 -z-10 h-[420px] w-[420px] -translate-x-1/2 rounded-full bg-cyan-400/10 blur-3xl" />
          <div className="pointer-events-none absolute top-20 -right-24 -z-10 h-[360px] w-[360px] rounded-full bg-indigo-400/10 blur-3xl" />

          <Container className="py-16 md:py-24 lg:py-28">
            <Fade direction="up" triggerOnce>
              <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-1 text-xs font-medium text-white/90 backdrop-blur">
                <span
                  aria-hidden="true"
                  className="inline-block h-2 w-2 rounded-full bg-accent motion-safe:animate-pulse"
                />
                {t("partners.eyebrow")}
              </span>
              <h1 className="mt-5 text-[clamp(1.5rem,4.2vw,3rem)] font-bold leading-tight tracking-tight bg-gradient-to-b from-white to-white/80 bg-clip-text text-transparent">
                {t("partners.title")}
              </h1>
              <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/80 md:text-lg">
                {t("partners.desc")}
              </p>
            </Fade>
          </Container>
        </section>

        {/* 파트너 로그인 카드 — 셀프서비스 영역 진입점 */}
        <PartnerLoginCard />

        {/* 협업 제안 CTA */}
        <section className="bg-slate-100 pb-16 md:pb-24">
          <Container>
            <Fade direction="up" triggerOnce>
              <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-10">
                <h3 className="text-xl font-bold text-slate-900 md:text-2xl">
                  {t("partners.inquireTitle")}
                </h3>
                <p className="mt-3 max-w-2xl text-sm leading-relaxed text-slate-600 md:text-base">
                  {t("partners.inquireDesc")}
                </p>
                <div className="mt-6 flex flex-wrap gap-3">
                  <Button variant="accent" href="/#contact">
                    {t("partners.inquireCta")}
                  </Button>
                  <Link to="/" className="btw-btn-ghost">
                    ← {t("partners.backCta")}
                  </Link>
                </div>
              </div>
            </Fade>
          </Container>
        </section>
      </main>

      <Footer />
    </div>
  );
}
